import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';

import { trackByValue } from '@recruitee/common';
import type { CandidateSharedWith } from '@recruitee/sharing-container-types';
import {
  AvatarComponent,
  BoxComponent,
  DividerComponent,
  IconButtonComponent,
  ScrollableDirective,
  ScrollTrapDirective,
} from '@recruitee/user-interface';

@Component({
  selector: 'rt-candidate-shared-with-list',
  imports: [
    BoxComponent,
    DividerComponent,
    AvatarComponent,
    IconButtonComponent,
    ScrollableDirective,
    ScrollTrapDirective,
    NgTemplateOutlet,
  ],
  templateUrl: './candidate-shared-with-list.component.html',
  styleUrls: ['./candidate-shared-with-list.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CandidateSharedWithListComponent {
  @Input() public sharedWithUsers: CandidateSharedWith[] = [];
  @Input() public withActions: boolean = false;
  @Input() public hasScroll = true;

  public stopSharingClick = output<CandidateSharedWith>();

  public trackByValue = trackByValue;
}
